import { render, staticRenderFns } from "./AddCombine.vue?vue&type=template&id=55a0f5d6&"
import script from "./AddCombine.vue?vue&type=script&lang=js&"
export * from "./AddCombine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports